// extracted by mini-css-extract-plugin
export var billingAddress = "_xo-g";
export var contactInfo = "_xo-d";
export var customerInfoContainer = "_xo-c";
export var customerInfoContainerMobile = "_xo-h";
export var customerInfoRow = "_xo-a";
export var customerInfoSection = "_xo-b";
export var fullWidthDividerMobile = "_xo-i";
export var imageContainer = "_xo-1";
export var paymentMethod = "_xo-e";
export var priceText = "_xo-6";
export var priceTextMobile = "_xo-7";
export var product = "_xo-0";
export var productImage = "_xo-2";
export var productInfo = "_xo-4";
export var productMobile = "_xo-9";
export var productTitle = "_xo-8";
export var quantityBadge = "_xo-3";
export var quantityText = "_xo-5";
export var shippingAddress = "_xo-f";